import { Box, Text } from "@chakra-ui/react";
import React from "react";

const OvendLogo = () => {
  return (
    <Box display={"flex"} alignItems={"center"} gap={"16px"}>
      <Box
        as="a"
        href="/"
        _hover={{textDecoration:'none'}}
        sx={{
          bg: "rgb(7,47,100)",
          color: "white",
          fontWeight: "700",
          p: "3",
          borderRadius: "10px",
          w: "44px",
          h: "44px",
          d: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "20px",
        }}
      >
        O
      </Box>
      <Text color={"black"} fontWeight={"500"} fontSize={["20px"]}>
        Ovend
      </Text>
    </Box>
  );
};

export default OvendLogo;
